window.addEventListener('scroll', function() {
    scrolled();
});
document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function(e) {
    var wishlist_item_count = window.WishListHero_SDK.GetWishListItemsCount();
    if (wishlist_item_count > 0) {
        document.querySelector(".wishlist-hero-items-count").style.display = "block";
    } else {
        document.querySelector(".wishlist-hero-items-count").style.display = "none";
    }
    document.querySelector(".wishlist-hero-items-count").innerHTML = wishlist_item_count;
    setTimeout(function() {
        var wishlist_icon = document.querySelectorAll('.size_popup-parent .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
        var wishlist_icon3 = document.querySelectorAll('.cart-item .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon3.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
        var wishlist_icon2 = document.querySelectorAll('.product-title-wishlist-wrapp .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon2.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 26 23" fill="none"><path d="M22.2341 4.22805C21.7004 3.72355 21.0668 3.32335 20.3694 3.0503C19.672 2.77726 18.9246 2.63672 18.1697 2.63672C17.4148 2.63672 16.6674 2.77726 15.97 3.0503C15.2726 3.32335 14.639 3.72355 14.1054 4.22805L12.9978 5.27457L11.8903 4.22805C10.8124 3.20948 9.35041 2.63725 7.82599 2.63725C6.30156 2.63725 4.83957 3.20948 3.76163 4.22805C2.6837 5.24662 2.07813 6.6281 2.07812 8.06858C2.07812 9.50907 2.6837 10.8905 3.76163 11.9091L4.86914 12.9556L12.9978 20.6367L21.1265 12.9556L22.2341 11.9091C22.768 11.4049 23.1915 10.8061 23.4804 10.1472C23.7694 9.4882 23.9181 8.78189 23.9181 8.06858C23.9181 7.35528 23.7694 6.64897 23.4804 5.99C23.1915 5.33103 22.768 4.73231 22.2341 4.22805Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
        var wishlist_icon4 = document.querySelectorAll('.searchWishList .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon4.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
        var wishlist_icon5 = document.querySelectorAll('.shopwishListbtn .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon5.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
    }, 4000);
});
function scrolled() {
    if (window.scrollY > 0) {
        document.body.classList.add("announcement-hide");
    } else {
        document.body.classList.remove("announcement-hide");
    }
}
function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
document.addEventListener("click", function(event) {
    var target = event.target;
    if (target && target.closest(".recent_serches_wrapper .rpeated_recentsearches")) {
        var dataValue = target.getAttribute("data-value");
        var searchInput = document.querySelector("input#Search-In-Template");
        var searchInput2 = document.querySelector("input#Search-In-Modal");
        if (searchInput) {
            searchInput.value = dataValue;
            var searchButton = document.querySelector("button.search__button.field__button");
            if (searchButton) {
                searchButton.click();
            }
        }
        if (searchInput2) {
            searchInput2.value = dataValue;
            var searchButton2 = document.querySelector("button.search__button.field__button");
            if (searchButton2) {
                searchButton2.click();
            }
        }
    }
});

document.querySelectorAll('.navList').forEach((elm)=>{
  elm.addEventListener('mouseenter', (target)=>{
    if( target.target.querySelector('.mega-menu') ){
      target.preventDefault();
      target.currentTarget.closest('.navList').classList.add('active');
      target.target.querySelector('.mega-menu').setAttribute('open','open');
      document.body.classList.add("NavActive");
      if(target.target.querySelector('.sidebar_images_wrapp')){
        if(!target.target.querySelector('.sidebar_images_wrapp').classList.contains("swiper-container-initialized")){
            new Swiper(target.target.querySelector('.sidebar_images_wrapp'), {
                loop: false, slidesPerView: 2, spaceBetween: 3, autoplay: { delay: 5000 },
                breakpoints: { 1920: {slidesPerView: 2,spaceBetween: 3},1028: {slidesPerView: 2,spaceBetween: 3},480: {slidesPerView: 1,spaceBetween: 3} }
            });          
        }
      }
    }
  });
  elm.addEventListener('mouseleave', (target)=>{
    if( target.target.querySelector('.mega-menu') ){
      target.currentTarget.closest('.navList').classList.remove('active');
      target.target.querySelector('.mega-menu').removeAttribute('open');
      document.body.classList.remove("NavActive");
    }
  });  
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(".size_popup-parent").forEach(function(element) {
        var inputLabelWrappers = element.querySelectorAll(".MainVariants .input-label-wrapper");
        var visibleElementsCount = 0;
        inputLabelWrappers.forEach(function(inputLabelWrapper) {
            var style = window.getComputedStyle(inputLabelWrapper);
            if (style.display !== 'none') {
                visibleElementsCount++;
            }
        });
        if (visibleElementsCount === 0) {
            var popupElement = element.querySelector(".product_listing_sizes-popup");
            if (popupElement) {
                popupElement.style.display = "none";
            }
        }
    });
    scrolled();
    var getslider = document.querySelector('.HiddenSlider');
    var cartList = document.querySelector('.CartProduct_List');
    var getdata = document.querySelector('.MainEmpty_Bag');
    var emptyBagPro = document.querySelector('.EmptyBag_pro');
    var cartSubmitBtn = document.querySelector('#checkout');
    if (getslider && cartList) {
        cartList.innerHTML = '<div class="Outer_ProductLists">' + getslider.innerHTML + '</div>';
    }
    if (getdata && emptyBagPro) {
        emptyBagPro.innerHTML = '<div class="MainEmpty_Bag">' + getdata.innerHTML + '</div>';
    }
    function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');
        return msie > 0 || trident > 0;
    }
    if (isIE()) {
        const cartSubmitInput = document.createElement('input');
        cartSubmitInput.setAttribute('name', 'checkout');
        cartSubmitInput.setAttribute('type', 'hidden');
        document.querySelector('#cart').appendChild(cartSubmitInput);
        cartSubmitBtn.addEventListener('click', function(event) {
            document.querySelector('#cart').submit();
        });
    }
    new Swiper('.custom_cart_grid-slider', {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 2.5,
        paginationClickable: true,
        breakpoints: {
            1920: {
                slidesPerView: 3,
                spaceBetween: 2.5
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 2.5
            },
            0: {
                slidesPerView: 2,
                spaceBetween: 2.5
            }
        }
    });
    var mySwiper = new Swiper('.inner-logos-wrapper.swiper-container', {
        freeMode: false,
        loop: false,
        slidesPerView: 4,
        spaceBetween: 50,
        pagination: {
            el: '.slider__pagination',
            clickable: true,
        },
        breakpoints: {
            1025: {
                slidesPerView: 4,
                spaceBetween: 50
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 50
            },
            320: {
                slidesPerView: 2,
                spaceBetween: 20
            }
        }
    });
    var ColorGroupVarnt = document.querySelectorAll('.shplookprdtinCnt .CustomImage')
    if (ColorGroupVarnt) {
        ColorGroupVarnt.forEach(function(item) {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelectorAll('.ColorGroupVrnt').forEach(function(color) {
                    color.classList.remove('active');
                })
                this.querySelector('.ColorGroupVrnt').classList.add('active')
            })
        })
    }
if (window.innerWidth > 749) {
    var announcementHeight = document.querySelector(".announcement-bar-section").offsetHeight;
    var headerHeight = document.querySelector(".section-header").offsetHeight;
    var modalContent = document.querySelector(".header__search .modal__content");
    modalContent.style.top = (announcementHeight + headerHeight) + 'px';
}
});
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('ViewText')) {
        var cartFooter = document.querySelector('.desktop_subpopu');
        if (cartFooter.classList.contains('Active_Summary')) {
            cartFooter.classList.remove('Active_Summary');
        } else {
            cartFooter.classList.add('Active_Summary');
        }
    }
});
document.addEventListener("click", function(e) {
    if (e.target.classList.contains("custom_listing_cart-btn")) {
        e.preventDefault();
        var allVariantsCartWrapper = e.target.closest(".all_variants_cart_wrapp");
        var selectedOption = allVariantsCartWrapper.querySelector("select option:checked");
        var get_varId = selectedOption.getAttribute("varid");
        let formData = {
            items: [{
                id: get_varId,
                quantity: 1
            }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok: ' + response.statusText);
            }
            return response.json();
        })
            .then(results => {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', '/cart', true);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        var html_get = xhr.responseText;
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: get_varId,
                            cartData: html_get
                        });
                      console.log(html_get);
                        var cartDrawer = document.querySelector('cart-drawer');
                        if (cartDrawer) {
                            cartDrawer.classList.add('active');
                            cartDrawer.classList.remove('is-empty');
                            var drawerInnerEmpty = document.querySelector('.drawer__inner-empty');
                            if (drawerInnerEmpty) {
                                drawerInnerEmpty.style.display = 'none';
                            }
                        }                   
                        document.querySelector('.cart_outer_empty_data').innerHTML = (new DOMParser().parseFromString(html_get, 'text/html')).querySelector('.cart_outer_empty_data').innerHTML;
                      document.querySelector('.drawer__footer').innerHTML = (new DOMParser().parseFromString(html_get, 'text/html')).querySelector('.drawer__footer').innerHTML;
                                              var headerIconCart = document.querySelector(".header__icon--cart");
                        var cartHTML = document.createElement('div');
                        cartHTML.innerHTML = html_get;
                        var cartIconHTML = cartHTML.querySelector('.header__icon--cart').innerHTML;
                        headerIconCart.innerHTML = cartIconHTML;

                        var headerIconCart2 = document.querySelector(".drawer__heading span");
                        var cartHTML2 = document.createElement('div');
                        cartHTML2.innerHTML = html_get;
                        var cartIconHTML2 = cartHTML2.querySelector('.drawer__heading span').innerHTML;
                        headerIconCart2.innerHTML = cartIconHTML2;

var data_subtotaltext = document.querySelector('cart-drawer').getAttribute('data-subtotaltext');
document.querySelector('span.suntotal_text_custom').textContent = data_subtotaltext;


                      
                    }
                };
                xhr.send();
            })
        .catch(error => {
            console.error('Error:', error); // Handle any errors
        });
    }
});

document.addEventListener("click", function(event) {
    if (event.target.closest(".cart-remove-button svg")) {
        event.preventDefault();
        var Obj = event.target.closest(".cart-remove-button").getAttribute("data-variant-id");

        let updates = {
            [Obj]: 0
        };
        fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates
                })
            })
            .then(response => {
                return response.json();
            })
            .then(results => {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', '/cart', true);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        var html_get = xhr.responseText;
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: Obj,
                            cartData: html_get
                        });
                      console.log(html_get);
                        var cartDrawer = document.querySelector('cart-drawer');
                        if (cartDrawer) {
                            cartDrawer.classList.add('active');
                            cartDrawer.classList.remove('is-empty');
                            var drawerInnerEmpty = document.querySelector('.drawer__inner-empty');
                            if (drawerInnerEmpty) {
                                drawerInnerEmpty.style.display = 'none';
                            }
                        }                   
                        document.querySelector('.cart_outer_empty_data').innerHTML = (new DOMParser().parseFromString(html_get, 'text/html')).querySelector('.cart_outer_empty_data').innerHTML;
                      document.querySelector('.drawer__footer').innerHTML = (new DOMParser().parseFromString(html_get, 'text/html')).querySelector('.drawer__footer').innerHTML;
                                              var headerIconCart = document.querySelector(".header__icon--cart");
                        var cartHTML = document.createElement('div');
                        cartHTML.innerHTML = html_get;
                        var cartIconHTML = cartHTML.querySelector('.header__icon--cart').innerHTML;
                        headerIconCart.innerHTML = cartIconHTML;

                        var headerIconCart2 = document.querySelector(".drawer__heading span");
                        var cartHTML2 = document.createElement('div');
                        cartHTML2.innerHTML = html_get;
                        var cartIconHTML2 = cartHTML2.querySelector('.drawer__heading span').innerHTML;
                        headerIconCart2.innerHTML = cartIconHTML2;

                      var data_subtotaltext = document.querySelector('cart-drawer').getAttribute('data-subtotaltext');
                      document.querySelector('span.suntotal_text_custom').textContent = data_subtotaltext;
                    }
                };
                xhr.send();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
});

document.addEventListener("change", function(event) {
    if (event.target.matches("select.custom_variants-listing")) {
        var selectedOption = event.target.options[event.target.selectedIndex];
        var get_qty = selectedOption.getAttribute("var-qty");
        var get_policy = selectedOption.getAttribute("var-policy");
        var get_id = selectedOption.getAttribute("varid");
        var button = event.target.closest(".all_variants_cart_wrapp").querySelector(".custom_listing_cart-btn");
        var add_button_text = event.target.closest(".all_variants_cart_wrapp").getAttribute("add-button-text");
        var sold_button_text = event.target.closest(".all_variants_cart_wrapp").getAttribute("sold-button-text");
        event.target.closest(".all_variants_cart_wrapp").querySelector('[name="id"]').value = get_id;
        if (get_qty > 0 || get_policy === 'countinue') {
            button.children[0].textContent = add_button_text;
            button.removeAttribute("disabled");
        } else {
            button.children[0].textContent = sold_button_text;   
            button.setAttribute("disabled", "disabled");
        }
    }
});

// document.addEventListener('click', function(event) {
//     if (event.target.closest('.image_upper_cartbtn .product_upper_cart-trigger svg')) {
//         var sizePopupParent = event.target.closest('.size_popup-parent');
//         if (sizePopupParent) {
//             var productListingSizesPopup = sizePopupParent.querySelector('.product_listing_sizes-popup');
//             if (productListingSizesPopup) {
//                 productListingSizesPopup.classList.add('show_popup');
//             }
//         }
//     }
// });
// document.addEventListener('click', function(event) {
//     if (event.target.closest('.listing-popup_cross_btn svg')) {
//         var sizePopupParent = event.target.closest('.size_popup-parent');
//         if (sizePopupParent) {
//             var productListingSizesPopup = sizePopupParent.querySelector('.product_listing_sizes-popup');
//             if (productListingSizesPopup) {
//                 productListingSizesPopup.classList.remove('show_popup');
//             }
//         }
//     }
// });
var elements = document.querySelectorAll(".first_menu_data");
elements.forEach(function(element) {
    element.addEventListener("click", function() {
        var parentLi = findParentLi(element);
        if (parentLi) {
            var isActive = parentLi.classList.contains("activemonile-menu");
            var mainLiLists = document.querySelectorAll(".has-submenu .mainLiList");
            mainLiLists.forEach(function(mainLiList) {
                mainLiList.classList.remove("activemonile-menu");
            });
            if (!isActive) {
                parentLi.classList.add("activemonile-menu");
            }
        }
    });
});
function findParentLi(element) {
    var parent = element.parentNode;
    while (parent) {
        if (parent.tagName.toLowerCase() === "li") {
            return parent;
        }
        parent = parent.parentNode;
    }
    return null;
}
document.addEventListener("click", function(event) {
    var target = event.target;
    if (target.classList.contains("menu-drawer__menu-item") || target.classList.contains("inner_menu_svg")) {
        var mobileSidebarImagesWrapp = document.querySelectorAll(".mobile-sidebar_images_wrapp");
        mobileSidebarImagesWrapp.forEach(function(element) {
            element.style.display = "none";
        });
    }
    if (target.classList.contains("first_menu_data") || target.classList.contains("custom_top_icon")) {
        var mobileSidebarImagesWrapp = document.querySelectorAll(".mobile-sidebar_images_wrapp");
        mobileSidebarImagesWrapp.forEach(function(element) {
            element.style.display = "none";
        });
        var dataHandle = target.closest("li").getAttribute("data-handle");
        var parentLi = target.closest("li");
        if (parentLi.classList.contains("activemonile-menu")) {
            var mobileSidebarImagesWrappWithDataHandle = document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']");
            if (mobileSidebarImagesWrappWithDataHandle) {
                mobileSidebarImagesWrappWithDataHandle.style.display = "block";
            }
            if (mobileSidebarImagesWrappWithDataHandle && mobileSidebarImagesWrappWithDataHandle.classList.contains("swiper-container-initialized")) {} else {
                new Swiper(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']", {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 3,
                    autoplay: {
                        delay: 5000,
                    }
                });
            }
        } else {
            var mobileSidebarImagesWrappWithDataHandle = document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']");
            if (mobileSidebarImagesWrappWithDataHandle) {
                mobileSidebarImagesWrappWithDataHandle.style.display = "none";
            }
        }
    }
});
var closeButtonElements = document.querySelectorAll(".menu-drawer__close-button");
closeButtonElements.forEach(function(closeButtonElement) {
    closeButtonElement.addEventListener("click", function() {
        setTimeout(function() {
            var dataHandle = document.querySelector("li.mainLiList.activemonile-menu").getAttribute("data-handle");
            // document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']").style.display = "block";
        }, 100);
    });
});
document.addEventListener("click", function(event) {
    var target = event.target;
    var crossSvg = document.querySelector(".cross_ccureency-swicher-wrapper .mobile-menu-cross-wrapper svg");
    var crossmain = document.querySelector(".cross_ccureency-swicher-wrapper .mobile-menu-cross-wrapper");
    var menuSummary = document.querySelector(".menu-opening summary");
    if (target === crossSvg || target === crossmain) {
        menuSummary.click();
        setTimeout(function() {
             var dataHandle = document.querySelector("li.mainLiList.activemonile-menu");
    if (dataHandle) {
        var handle = dataHandle.getAttribute("data-handle");
       // document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + handle + "']").style.display = "block";
    }
            
        }, 100);
    }
});
function validateEmail() {
    var email = document.getElementById("NewsletterForm--email").value;
    var value_length = email.length;
    if (value_length > 0) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(email)) {
            document.getElementById("emailError").innerText = "";
            document.getElementById("Subscribe").removeAttribute("disabled");
            document.querySelector(".newsletter-form__field-wrapper").classList.remove("show_error_msg");
        } else {
            document.querySelector(".newsletter-form__field-wrapper").classList.add("show_error_msg");
            document.getElementById("emailError").innerText = "*Please include an @ in the email address";
            document.getElementById("Subscribe").setAttribute("disabled", "disabled");
        }
    } else {
        document.getElementById("emailError").innerText = "";
        document.getElementById("Subscribe").removeAttribute("disabled");
        document.querySelector(".newsletter-form__field-wrapper").classList.remove("show_error_msg");
    }
}
document.addEventListener("mouseup", function(e) {
    var drawerInner = document.querySelector(".drawer__inner");
    var cartDrawer = document.querySelector("cart-drawer.drawer");
    if (!drawerInner.contains(e.target)) {
        cartDrawer.classList.remove("active");
    }
});
// var headings = document.querySelectorAll(".footer-block--menu .footer-block__heading");
// headings.forEach(function(heading) {
//     heading.addEventListener("click", function() {
//         this.parentNode.classList.toggle("active_acco");
//     });
// });
document.addEventListener("DOMContentLoaded", function() {
    const countryInterval = setInterval(switcher, 1000);

    function switcher() {
        if (window.innerWidth < 990) {
            var doublyWrapper = document.querySelector(".doubly-wrapper");
            var mobileLocalizationWrapper = document.querySelector(".mobile_localize_form");

            if (doublyWrapper && mobileLocalizationWrapper) {
                mobileLocalizationWrapper.parentNode.insertBefore(doublyWrapper, mobileLocalizationWrapper.nextSibling);
                doublyWrapper.style.display = "block";
            } else {
                // console.error("Elements not found:", { doublyWrapper, mobileLocalizationWrapper });
            }
            clearInterval(countryInterval);
        }
    }
});

document.addEventListener("click", function(event) {
    var target = event.target;
    var wishlist_icon_man = document.querySelectorAll('.wishlist-hero-custom-button.wishlisthero-floating button svg');
    wishlist_icon_man.forEach(function(wishlist) {
        setTimeout(function() {
            var wishlist_item_count = window.WishListHero_SDK.GetWishListItemsCount();
            var wishlist_items_count_element = document.querySelector(".wishlist-hero-items-count");
            if (wishlist_item_count > 0) {
                wishlist_items_count_element.style.display = "block";
            } else {
                wishlist_items_count_element.style.display = "none";
            }
            wishlist_items_count_element.innerHTML = wishlist_item_count;
        }, 1200);
    });
});
document.addEventListener("click", function(event) {
    var cartOverlay = document.querySelector("div#CartDrawer-Overlay");
    var body = document.querySelector("body");
    if (event.target === cartOverlay) {
        body.classList.remove("overflow-hidden");
    }
});
document.addEventListener("click", function(event) {
    var cartOverlay = document.querySelector("div#CartDrawer-Overlay");
    var body = document.querySelector("body");
    if (event.target === cartOverlay) {
        body.classList.remove("overflow-hidden");
    }
});
window.addEventListener('resize', function() {
    if (window.innerWidth < 990) {
        var doublyWrapper = document.querySelector(".doubly-wrapper");
        var mobileLocalizationWrapper = document.querySelector(".mobile_localize_form");
        mobileLocalizationWrapper.parentNode.insertBefore(doublyWrapper, mobileLocalizationWrapper.nextSibling);
    } else {
        var doublyWrapper = document.querySelector(".doubly-wrapper");
        var cartIconBubble = document.querySelector("a#cart-icon-bubble");
        cartIconBubble.parentNode.insertBefore(doublyWrapper, cartIconBubble.nextSibling);
    }
  if (window.innerWidth > 749) {
    var announcementHeight = document.querySelector(".announcement-bar-section").offsetHeight;
    var headerHeight = document.querySelector(".section-header").offsetHeight;
    var modalContent = document.querySelector(".header__search .modal__content");
    modalContent.style.top = (announcementHeight + headerHeight) + 'px';
}else{
     var modalContent = document.querySelector(".header__search .modal__content");
    modalContent.style.top = '0px';
}
});